import { render } from "./PosLeftbarOld.vue?vue&type=template&id=8f20763e&scoped=true"
import script from "./PosLeftbarOld.vue?vue&type=script&lang=js"
export * from "./PosLeftbarOld.vue?vue&type=script&lang=js"

import "./PosLeftbarOld.vue?vue&type=style&index=0&id=8f20763e&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f20763e"]])

export default __exports__